import { AuthGuard, CheckPermissionsModes } from "@elit-hair/elit-tools";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { NotAuthorizedPage } from "@/pages/not-authorized/-index";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.EVENTS)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "events",
                to: APP_ROUTES_TO.EVENTS,
            },
            title: "events",
        },
        permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function RouteComponent() {
    return (
        <AuthGuard
            required={[PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE]}
            permissionMode={CheckPermissionsModes.ANY}
            fallback={<NotAuthorizedPage />}
        >
            <Outlet />
        </AuthGuard>
    );
}
